import * as types from "../mutation-types";

const state = {
	users: [],
	selectedUser: null
};

const getters = {
	users: state => state.users,
	selectedUser: state => state.selectedUser
};

const actions = {
	fetchUsers({ commit, dispatch }) {
		return dispatch("request/fetchUsers", null, { root: true })
			.then(users => commit(types.SET_USERS, users));
	},
	addNewUser({ commit, dispatch }, user) {
		return dispatch("request/addUser", user, { root: true })
			.then(newUser => 	commit(types.ADD_NEW_USER, newUser));
	},
	updateUser({ commit, dispatch }, user) {
		return dispatch("request/updateUser", user, { root: true })
			.then(updatedUser => commit(types.UPDATE_USER, updatedUser));
	},
	setSelectedUser({ commit }, user) {
		return commit(types.SET_SELECTED_USER, user);
	}
};

const mutations = {
	[types.SET_USERS](state, users) {
		state.users = users;
	},
	[types.ADD_NEW_USER](state, user) {
		state.users.push(user);
	},
	[types.UPDATE_USER](state, user) {
		const index = state.users.findIndex(u => u._key === user._key);
		state.users.splice(index, 1, user);
		state.selectedUser = user;
	},
	[types.SET_SELECTED_USER](state, user) {
		state.selectedUser = user;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/users.js